"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSidepaneToggle = exports.useSidepaneState = exports.useSidepaneReset = exports.useIsSidepaneTypeOpen = void 0;
var _reactSdk = require("@100mslive/react-sdk");
var _react = require("react");
var _constants = require("../../common/constants");
/**
 * Gives a boolean value if the sidepaneType matches current sidepane value in store
 * @param {string} sidepaneType
 * @returns {boolean} - if the sidepaneType is passed returns boolean else the current value
 */
var useIsSidepaneTypeOpen = function useIsSidepaneTypeOpen(sidepaneType) {
  if (!sidepaneType) {
    throw Error("Pass one of the side pane options");
  }
  return (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppData)(_constants.APP_DATA.sidePane)) === sidepaneType;
};

/**
 * Gives the current value of sidepane in store
 * @returns {string} - if the sidepaneType is passed returns boolean else the current value
 */
exports.useIsSidepaneTypeOpen = useIsSidepaneTypeOpen;
var useSidepaneState = function useSidepaneState() {
  var sidePane = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppData)(_constants.APP_DATA.sidePane));
  return sidePane;
};

/**
 * Toggle the sidepane value between passed sidePaneType and '';
 * @param {string} sidepaneType
 */
exports.useSidepaneState = useSidepaneState;
var useSidepaneToggle = function useSidepaneToggle(sidepaneType) {
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var vanillaStore = (0, _reactSdk.useHMSVanillaStore)();
  var toggleSidepane = (0, _react.useCallback)(function () {
    var isOpen = vanillaStore.getState((0, _reactSdk.selectAppData)(_constants.APP_DATA.sidePane)) === sidepaneType;
    hmsActions.setAppData(_constants.APP_DATA.sidePane, !isOpen ? sidepaneType : "");
  }, [vanillaStore, hmsActions, sidepaneType]);
  return toggleSidepane;
};

/**
 * reset's the sidepane value
 */
exports.useSidepaneToggle = useSidepaneToggle;
var useSidepaneReset = function useSidepaneReset() {
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var resetSidepane = (0, _react.useCallback)(function () {
    hmsActions.setAppData(_constants.APP_DATA.sidePane, "");
  }, [hmsActions]);
  return resetSidepane;
};
exports.useSidepaneReset = useSidepaneReset;